// @ts-nocheck
import {
    getCategorySearchCollection,
    getCategorySearchDataView,
    getCategorySearchItems,
} from "@store/Framework/Store/Data/CategorySearch/CategorySearchSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useCategorySearchDataView = convertSelectorToHook(getCategorySearchDataView);
export const useCategorySearchItems = convertSelectorToHook(getCategorySearchItems);
export const useCategorySearchCollection = convertSelectorToHook(getCategorySearchCollection);
